import {
  getQueryStringParameter,
  clearInputField
} from "../../helpers";

$(document).ready(() => {
  const $form = $("form#natural-profile-form, form#legal-profile-form");

  if ($form.length === 0 || getQueryStringParameter("id") !== "sustainability_preferences") {
    return;
  }

  const NONE_VALUE = "none_of_the_above";
  const ENVIRONMENTALLY_VALUE = "environmentally_sustainable_investments";
  const SUSTAINABLE_VALUE = "sustainable_investments";
  const CONSIDERING_VALUE = "investments_considering_sustainability_factors";

  const $checkboxes = $(".sustainability-preferences-checkbox", $form);
  const $environmentallyField = $("#environmentally-sustainable-percentage-field", $form);
  const $sustainableField = $("#sustainable-percentage-field", $form);
  const $consideringField = $("#principal-adverse-impacts-field", $form);
  const $warning = $("#sustainability-preferences-warning", $form);

  const fieldFor = (value) => {
    if (value === ENVIRONMENTALLY_VALUE) return $environmentallyField;
    if (value === SUSTAINABLE_VALUE) return $sustainableField;
    if (value === CONSIDERING_VALUE) return $consideringField;
    return null;
  };

  const clearInputsIn = ($container) => {
    $("input", $container).each((_, inputElement) => {
      clearInputField(inputElement);
    });
  };

  const refreshSubfields = () => {
    $checkboxes.each((_, element) => {
      const $field = fieldFor(element.value);
      if (!$field) return;

      if (element.checked) {
        $field.removeClass("d-none");
      } else {
        $field.addClass("d-none");
        clearInputsIn($field);
      }
    });
  };

  const refreshWarning = () => {
    const checkedValues = $checkboxes
      .filter((_, element) => element.checked)
      .map((_, element) => element.value)
      .get();

    const showWarning = checkedValues.includes(ENVIRONMENTALLY_VALUE) ||
                        checkedValues.includes(SUSTAINABLE_VALUE);

    if (showWarning) {
      $warning.removeClass("d-none");
    } else {
      $warning.addClass("d-none");
    }
  };

  $checkboxes.on("change", (e) => {
    const target = e.target;

    if (target.checked && target.value === NONE_VALUE) {
      $checkboxes.each((_, element) => {
        if (element.value !== NONE_VALUE && element.checked) {
          element.checked = false;

          const $field = fieldFor(element.value);
          if ($field) {
            $field.addClass("d-none");
            clearInputsIn($field);
          }
        }
      });
    } else if (target.checked && target.value !== NONE_VALUE) {
      const $noneCheckbox = $checkboxes.filter(`[value="${NONE_VALUE}"]`);
      if ($noneCheckbox.prop("checked")) {
        $noneCheckbox.prop("checked", false);
      }
    }

    refreshSubfields();
    refreshWarning();
  });
});
